import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './achievements.reducer';

export const AchievementsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const achievementsEntity = useAppSelector(state => state.achievements.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="achievementsDetailsHeading">
          <Translate contentKey="fivePlusApp.achievements.detail.title">Achievements</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{achievementsEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fivePlusApp.achievements.name">Name</Translate>
            </span>
          </dt>
          <dd>{achievementsEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fivePlusApp.achievements.description">Description</Translate>
            </span>
          </dt>
          <dd>{achievementsEntity.description}</dd>
          <dt>
            <span id="feature">
              <Translate contentKey="fivePlusApp.achievements.feature">Feature</Translate>
            </span>
          </dt>
          <dd>{achievementsEntity.feature ? 'true' : 'false'}</dd>
          <dt>
            <span id="requiredProof">
              <Translate contentKey="fivePlusApp.achievements.requiredProof">Required Proof</Translate>
            </span>
          </dt>
          <dd>{achievementsEntity.requiredProof ? 'true' : 'false'}</dd>
          <dt>
            <span id="displayName">
              <Translate contentKey="fivePlusApp.achievements.displayName">Display Name</Translate>
            </span>
          </dt>
          <dd>{achievementsEntity.displayName}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.achievements.pointDetails">Point Details</Translate>
          </dt>
          <dd>{achievementsEntity.pointDetails ? achievementsEntity.pointDetails.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/achievements" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/achievements/${achievementsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AchievementsDetail;
